import axios, { AxiosError } from 'axios'
import { i18n } from '@/i18n'

const apiOrigin = (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/$/, '')

export const http = axios.create({
  baseURL: `${apiOrigin}/api`,
  timeout: 15_000,
  headers: {
    Accept: 'application/json',
  },
})

http.interceptors.request.use((config) => {
  config.headers.set('x-custom-lang', i18n.global.locale.value)
  return config
})

export class ApiError extends Error {
  readonly status?: number
  readonly details: unknown

  constructor(message: string, options?: { status?: number; details?: unknown }) {
    super(message)
    this.name = 'ApiError'
    this.status = options?.status
    this.details = options?.details
  }
}

export const normalizeApiError = (error: unknown): ApiError => {
  if (error instanceof ApiError) return error

  if (error instanceof AxiosError) {
    const message =
      (typeof error.response?.data === 'object' && error.response?.data !== null && 'message' in error.response.data
        ? String(error.response.data.message)
        : error.message) || 'Request failed'

    return new ApiError(message, {
      status: error.response?.status,
      details: error.response?.data,
    })
  }

  return new ApiError(error instanceof Error ? error.message : 'Unknown request error', { details: error })
}
